import { NgModule } from '@angular/core';
import { HomePage } from 'pages/home/home';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [HomePage],
    imports: [PagesModule, ComponentsModule],
    exports: [HomePage]
})
export class HomePageModule {}
